import { useQuery } from '@tanstack/react-query';

import { useLocale } from '@/shared/hooks/useLocale';

import { fetchExperts } from '../../helpers/api';

export const useExpertsQuery = () => {
  const { internalLocale } = useLocale();
  const { data: expertsList } = useQuery({
    queryKey: ['experts', internalLocale],
    queryFn: () => fetchExperts(internalLocale),
    select: (data) => data.experts,
  });

  return { expertsList };
};
